import {Contact, ContactPhoneNumber} from "models"
import {Pressable, View} from "react-native"
import React, {useMemo} from "react"
import {shapeComponent, ShapeComponent} from "set-state-compare/src/shape-component"
import AppHistory from "shared/history"
import ContactPhoneNumbersTable from "components/contact-phone-numbers/table"
import Icon from "@kaspernj/api-maker/build/utils/icon"
import memo from "set-state-compare/src/memo"
import Nav from "./nav"
import Routes from "shared/routes"
import {useAdminLayout} from "components/admin/layout"
import useI18n from "i18n-on-steroids/src/use-i18n.mjs"
import useModel from "@kaspernj/api-maker/build/use-model"
import {useParams} from "@kaspernj/api-maker/build/router/route"

export default memo(shapeComponent(class RoutesAdminContactsPhoneNumbers extends ShapeComponent {
  setup() {
    const {t} = useI18n({namespace: "js.routes.admin.contacts.phone_numbers"})
    const params = useParams()
    const {contact, contactId} = useModel(Contact, {
      match: {params},
      select: {
        Contact: ["contactPointsCount", "id"]
      }
    })
    const contactPhoneNumbersQuery = useMemo(() => ContactPhoneNumber.ransack({contact_id_eq: contactId}), [contactId])

    this.setInstance({contact, contactPhoneNumbersQuery, contactId})

    useAdminLayout()?.setState({actions: this.actions(), active: "contacts", headerTitle: t(".phone_numbers")})
  }

  render() {
    const {contact, contactPhoneNumbersQuery} = this.tt

    return (
      <View dataSet={this.rootViewDataSet ||= {route: "admin/contacts/phone-numbers"}}>
        {contact &&
          <Nav active="phone-numbers" contact={contact} style={this.navStyle ||= {marginBottom: 10}} />
        }
        <ContactPhoneNumbersTable collection={contactPhoneNumbersQuery} />
      </View>
    )
  }

  actions = () => <>
    <Pressable dataSet={this.addPhoneNumberPressableDataSet ||= {class: "add-phone-number-action"}} onPress={this.tt.onAddPhoneNumberPress}>
      <Icon name="pen" version="FontAwesome6" />
    </Pressable>
  </>

  onAddPhoneNumberPress = () => AppHistory.push(Routes.newAdminContactPhoneNumberPath({contact_phone_number: {contact_id: this.tt.contactId}}))
}))
